import { Box, Card, Flex, Separator, SubTitle, Text } from "@shared/primitive-components"
import { formatPercentage } from "@shared/utils/formatters/formatPercentage"
import { SpeedingBreakdown } from "."
import { Trip } from "../../../api/insights"
import { tripCardStyles as styles } from "../../styles"

export const TRIP_CARD_DTI = {
  SPEEDING: `trip_card_score_speeding`,
  EXCEEDANCE_AVG: `trip_card_score_exceedance_avg`,
  SAFE_MILES: `trip_card_score_safe_miles`,
  UNSAFE_MILES: `trip_card_score_unsafe_miles`,
}

export type TripCardProps = {
  trip: Trip
}

export const TripCard = ({ trip }: TripCardProps) => (
  <Card>
    <Box css={styles.detailsContainer}>
      <Flex alignItems="center">
        <SubTitle>Trip Data</SubTitle>
      </Flex>
      <Separator size="block" color="yellow" css={styles.marginBottom} />
      <Flex>
        <Box css={styles.marginRight}>
          <Text use="headline2" tag="h4" css={styles.tripScoreHeading}>
            Miles spent speeding
          </Text>
          <Text data-testid={TRIP_CARD_DTI.SPEEDING}>{formatPercentage(trip.analytics.distanceSpentSpeeding, 1)}</Text>
        </Box>
        <Box css={styles.marginRight}>
          <Text use="headline2" tag="h4" css={styles.tripScoreHeading}>
            Average speed exceedance
          </Text>
          <Text data-testid={TRIP_CARD_DTI.EXCEEDANCE_AVG}>
            {formatPercentage(trip.analytics.averageSpeedExceedencePercentage, 1)}
          </Text>
        </Box>
        <Box css={styles.marginRight}>
          <Text use="headline2" tag="h4" css={styles.tripScoreHeading}>
            Unsafe miles
          </Text>
          <Text css={styles.textAlignRight} data-testid={TRIP_CARD_DTI.UNSAFE_MILES}>
            {trip.analytics.unsafeMiles}
          </Text>
        </Box>
        <Box css={styles.marginRight}>
          <Text use="headline2" tag="h4" css={styles.tripScoreHeading}>
            Speeding breakdown
          </Text>
          <SpeedingBreakdown speedBands={trip.analytics.speedBands} extended />
        </Box>
        <Box css={styles.marginRight}>
          <Text use="headline2" tag="h4" css={styles.tripScoreHeading}>
            Safe miles
          </Text>
          <Text data-testid={TRIP_CARD_DTI.SAFE_MILES}>{trip.analytics.safeMiles}</Text>
        </Box>
      </Flex>
    </Box>
  </Card>
)

export type Props = {
  vrn: string
}
